import TopLoadingBar from './TopLoadingBar';

export default TopLoadingBar;
